const SAFE_NON_ASCII = /^[A-Za-z0-9\-_.!~*'()]$/;
export function urlEncode(input, opts = { mode: 'non-ascii' }) {
    const upper = opts.upperHex ?? true;
    const charset = opts.charset ?? 'utf-8';
    if (opts.mode === 'none')
        return input;
    const bytesFor = (ch) => {
        if (charset === 'latin1') {
            const code = ch.charCodeAt(0);
            return code <= 0xff ? [code] : Array.from(new TextEncoder().encode(ch));
        }
        return Array.from(new TextEncoder().encode(ch));
    };
    const fmt = (b) => {
        const hex = b.toString(16).padStart(2, '0');
        return '%' + (upper ? hex.toUpperCase() : hex);
    };
    if (opts.mode === 'all') {
        let out = '';
        for (const ch of input)
            for (const b of bytesFor(ch))
                out += fmt(b);
        return out;
    }
    if (opts.mode === 'non-ascii') {
        return encodeURIComponent(input);
    }
    const include = new Set(opts.range?.include ?? '');
    const exclude = new Set(opts.range?.exclude ?? '');
    let out = '';
    for (const ch of input) {
        if (exclude.has(ch)) {
            out += ch;
            continue;
        }
        if (include.has(ch) || !SAFE_NON_ASCII.test(ch)) {
            for (const b of bytesFor(ch))
                out += fmt(b);
        }
        else {
            out += ch;
        }
    }
    return out;
}
export function urlDecode(input) {
    try {
        return decodeURIComponent(input);
    }
    catch {
        return input.replace(/%([0-9a-fA-F]{2})/g, (_, h) => String.fromCharCode(parseInt(h, 16)));
    }
}
export function htmlEncode(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
export function htmlDecode(value) {
    if (typeof DOMParser !== 'undefined') {
        const doc = new DOMParser().parseFromString(value, 'text/html');
        return doc.documentElement.textContent ?? '';
    }
    return value
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, '&');
}
export function jsStringEncode(value) {
    return JSON.stringify(value).slice(1, -1);
}
export function jsStringDecode(value) {
    const quoted = `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
    return JSON.parse(quoted);
}
export function base64Encode(value) {
    return btoa(unescape(encodeURIComponent(value)));
}
export function base64Decode(value) {
    return decodeURIComponent(escape(atob(value)));
}
export function applyTransform({ direction, kind, value, urlOpts, }) {
    try {
        if (direction === 'encode') {
            switch (kind) {
                case 'url':
                    return urlEncode(value, urlOpts ?? { mode: 'non-ascii' });
                case 'html':
                    return htmlEncode(value);
                case 'js':
                    return jsStringEncode(value);
                case 'base64':
                    return base64Encode(value);
            }
        }
        switch (kind) {
            case 'url':
                return urlDecode(value);
            case 'html':
                return htmlDecode(value);
            case 'js':
                return jsStringDecode(value);
            case 'base64':
                return base64Decode(value);
        }
    }
    catch {
        return value;
    }
}
